import * as React from "react";
import { CgEye } from "react-icons/cg";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { titleCase } from "change-case-all";
import { tableCellClasses } from "@mui/material/TableCell";

import { convertDate } from "../../../utils";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },
  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ name, agent, fields, setDialogState }) {
  return (
    <TableContainer
      sx={{ maxHeight: 440, borderRadius: "10px" }}
      component={Paper}
    >
      <Table stickyHeader sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead style={{ height: "65px" }}>
          <TableRow>
            {fields?.map((column, index) => (
              <StyledTableCell>
                {titleCase(column.name?.replace(/_/g, " "))}
              </StyledTableCell>
            ))}

            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {agent?.map((row, rowIndex) => (
            <StyledTableRow key={rowIndex}>
              {fields?.map((column, colIndex) => (
                <StyledTableCell component="th" scope="row" key={colIndex}>
                  {row.channel_id === 3 && column.name === "expiry_token"
                    ? convertDate(row[column?.name])
                    : row[column?.name]?.length > 30
                    ? row[column?.name]?.substr(0, 30)
                    : row[column?.name]}
                </StyledTableCell>
              ))}

              <StyledTableCell>
                <Tooltip title="View Agent">
                  <Icon
                    onClick={() => {
                      setDialogState({
                        state: true,
                        update: true,
                        key: name,
                        agents: agent,
                        data: row,
                        index: rowIndex,
                      });
                    }}
                  >
                    <CgEye />
                  </Icon>
                </Tooltip>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
